import React from 'react'
import { AlertCircle } from 'lucide-react'

interface FormFieldProps {
 label: string
 required?: boolean
 error?: string
 hint?: string
 children: React.ReactNode
 className?: string
}

export const FormField: React.FC<FormFieldProps> = ({
 label,
 required = false,
 error,
 hint,
 children,
 className = ''
}) => {
 return (
 <div className={className}>
 <label className="block text-sm font-medium text-foreground mb-1">
 {label}
 {required && <span className="text-red-500 ml-1">*</span>}
 </label>
 {children}
 {hint && !error && (
 <p className="mt-1 text-xs text-muted-foreground">{hint}</p>
 )}
 {error && (
 <div className="mt-1 flex items-center text-xs text-red-600 dark:text-red-400">
 <AlertCircle className="h-3 w-3 mr-1" />
 {error}
 </div>
 )}
 </div>
 )
}

